import React from "react";
import snapGradLogo from "../assets/SnapGrad-By-Snaphomz_01.png";

export default function Footer() {
  const [logoFailed, setLogoFailed] = React.useState(false);
  return (
    <footer className="relative overflow-hidden bg-white py-8 md:py-10">
      <div className="relative z-10 w-full px-4 md:px-20">
        <div className="flex w-full flex-col gap-10 pt-6 pb-8 md:flex-row md:gap-12 md:pt-8">

          {/* Brand block */}
          <div className="min-w-[240px] flex-shrink-0 flex flex-col items-start text-left gap-2">
            {/* Logo */}
            {!logoFailed ? (
              <img
                src={snapGradLogo}
                alt="SnapGrad"
                className="block h-10 w-auto max-w-[260px] object-contain"
                onError={() => setLogoFailed(true)}
              />
            ) : (
              <div className="text-lg font-semibold text-gray-900">SnapGrad</div>
            )}

            {/* Company info + socials */}
            <div className="flex flex-col gap-0.5">
              <p className="mt-2 text-muted-foreground text-sm dark:text-[#EFEDFDB3]/60">
                Snaphomz Inc
              </p>
              <p className="text-muted-foreground text-sm dark:text-[#EFEDFDB3]/60">
                NMLS ID: 2790448
              </p>

              <div className="mt-1 flex flex-col gap-2">
                <div className="-ml-1 mt-3 flex items-center gap-2 md:mt-auto">
                  <a
                    target="_blank"
                    rel="noreferrer"
                    aria-label="linkedin"
                    className="inline-flex h-8 w-8 items-center justify-center leading-none transition-opacity hover:opacity-80"
                    href="https://www.linkedin.com/company/snaphomz"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="h-5 w-5"
                    >
                      <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
                      <rect width="4" height="12" x="2" y="9" />
                      <circle cx="4" cy="4" r="2" />
                    </svg>
                  </a>

                  <a
                    target="_blank"
                    rel="noreferrer"
                    aria-label="instagram"
                    className="inline-flex h-8 w-8 items-center justify-center leading-none transition-opacity hover:opacity-80"
                    href="https://www.instagram.com/snaphomz/"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="h-5 w-5"
                    >
                      <rect width="20" height="20" x="2" y="2" rx="5" ry="5" />
                      <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
                      <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
                    </svg>
                  </a>

                  <a
                    target="_blank"
                    rel="noreferrer"
                    aria-label="twitter"
                    className="inline-flex h-8 w-8 items-center justify-center leading-none transition-opacity hover:opacity-80"
                    href="https://x.com/snaphomz"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 1668.56 1221.19"
                      fill="currentColor"
                      className="h-5 w-5"
                    >
                      <path
                        d="M283.94,167.31l386.39,516.64L281.5,1104h87.51l340.42-367.76L984.48,1104h297.8L874.15,558.3l361.92-390.99h-87.51l-313.51,338.7l-253.31-338.7H283.94z
                          M412.63,231.77h136.81l604.13,807.76h-136.81L412.63,231.77z"
                        transform="translate(52.39 -25.059)"
                      />
                    </svg>
                  </a>

                  <a
                    target="_blank"
                    rel="noreferrer"
                    aria-label="tiktok"
                    className="inline-flex h-8 w-8 items-center justify-center leading-none transition-opacity hover:opacity-80"
                    href="https://www.tiktok.com/@snaphomz_usa"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="h-5 w-5"
                    >
                      <path d="M15 2v3.5c1.1 1.2 2.6 1.9 4 2v2.4c-1.5-.1-2.9-.6-4-1.5v6.8a4.8 4.8 0 1 1-4.2-4.7v3a1.9 1.9 0 1 0 1.2 1.7V2h3" />
                      <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Legal */}
          <div className="min-w-[140px] flex-shrink-0">
            <h3 className="text-sm font-medium text-gray-900">Legal</h3>

            <div className="mt-6 flex flex-col gap-5 text-sm text-gray-600">
              <a
                href="https://snaphomz.com/privacy-policy"
                className="transition-colors hover:text-gray-900"
              >
                Privacy
              </a>
              <a
                href="https://snaphomz.com/terms-and-conditions"
                className="transition-colors hover:text-gray-900"
              >
                Terms
              </a>
            </div>
          </div>

          {/* Disclaimer */}
          <div className="flex-1">
            <p className="text-xs leading-relaxed text-gray-700/80 md:text-sm">
              <span className="font-medium text-gray-900">Disclaimer:</span>{" "}
              SnapGrad helps students and families search, compare, and choose
              schools, and explore nearby housing options for planning purposes
              only. Information may be incomplete or out of date and should be
              verified with official sources. SnapGrad does not provide
              educational, legal, financial, or real estate advice.
            </p>
            {/* Link moved here, with color updated for visibility on white background */}
            <a
              href="https://snaphomz.com/do-not-sell-or-share"
              className="mt-4 inline-block text-xs md:text-sm text-gray-600 underline transition-colors hover:text-gray-900"
            >
              Do Not Sell or Share My Personal Information
            </a>
          </div>
        </div>

        <div className="border-t border-gray-200 pt-4">
          <p className="text-sm text-gray-600">SnapGrad. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
